<template>
  <div class="asc-custom-alerts">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AscCustomAlerts',
}
</script>
